import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  rowContainer: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  iconContainer: {
    backgroundColor: colors.secondary.softOrchid,
    borderRadius: scale(12),
    padding: scale(4),
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    color: colors.neutral.charcoal,
    marginLeft: scale(8),
    flex: 1,
  },
});

export default styles;
